function supportsCanvas() {
  var elem = document.createElement('canvas');
  return !!(elem.getContext && elem.getContext('2d'));
}

function supportsWebWorker() {
  return typeof Worker !== 'undefined';
}

function supportsWebComponents() {
  return 'customElements' in window && 'define' in window.customElements;
}

function supportsLocalStorage() {
  return 'localStorage' in window;
}

function supportsFetch() {
  return 'fetch' in window;
}

export function checkCompatibility() {
  const hasCanvas = supportsCanvas();
  const hasWebWorker = supportsWebWorker();
  const hasWebComponents = supportsWebComponents();
  const hasLocalStorage = supportsLocalStorage();
  const hasFetch = supportsFetch();
  const browserIsSupported =
    hasCanvas &&
    hasWebWorker &&
    hasWebComponents &&
    hasLocalStorage &&
    hasFetch;

  if (!browserIsSupported) {
    console.info({
      hasCanvas,
      hasWebWorker,
      hasWebComponents,
      hasLocalStorage,
      hasFetch,
    });
  }

  return browserIsSupported;
}
